import {createAction} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import {setEnabledFeatures} from '../../../features/actions'
import {setViewerSettings} from '../../../administration/userManagement/common/actions'
import {getFullUserInfo, getUserPanelErrors} from './selectors'
import {ValidationErrors} from '../constants'
import {validateTimezoneGroup} from '../validation'

export const setSimpleFullUserInfo = createAction(ActionTypes.FULL_USER_INFO_SET)

export const updateExtendedData = createAction(ActionTypes.EXTENDED_DATA_UPDATE)

export const setUserManageAssignmentsData = createAction(ActionTypes.USER_MANAGE_ASSIGNMENTS_DATA_SET)

export const setUserManagementAssignmentsSelection = createAction(ActionTypes.USER_MANAGEMENT_ASSIGNMENTS_SELECTION_SET)

export const setUserTeamAssignmentsData = createAction(ActionTypes.USER_TEAM_ASSIGNMENTS_DATA_SET)

export const setUserData = createAction(ActionTypes.USER_DATA_SET)

export const addUserPanelErrors = createAction(ActionTypes.USER_PANEL_ERROR_ADD)

export const setPasswordValidationResult = createAction(ActionTypes.USER_PANEL_PASSWORD_VALIDATION_RESULT_SET)

export const setUserPanelErrors = createAction(ActionTypes.USER_PANEL_ERRORS_SET)

export const removeUserPanelErrors = createAction(ActionTypes.USER_PANEL_ERRORS_REMOVE)

export const clearUserPanelErrors = createAction(ActionTypes.USER_PANEL_ERRORS_CLEAR)

export const setUserPanelHasLeavesOrTTBeforeNewHireDateError = createAction(ActionTypes.USER_PANEL_HAS_LEAVES_OR_TT_BEFORE_NEW_HIRE_DATE_ERROR)

export const setManagementAssignmentsCountsLoaded = createAction(ActionTypes.MANAGEMENT_ASSIGNMENTS_COUNTS_LOADED_SET)

export const managementAssignmentsCountsLoad = createAction(ActionTypes.MANAGEMENT_ASSIGNMENTS_COUNTS_LOAD)

export const managementAssignmentsCountsLoadSuccess = createAction(ActionTypes.MANAGEMENT_ASSIGNMENTS_COUNTS_LOAD_SUCCESS)

export const managementAssignmentsCountsLoadFailure = createAction(ActionTypes.MANAGEMENT_ASSIGNMENTS_COUNTS_LOAD_FAILURE)

export const setUserGroupData = createAction(ActionTypes.USER_GROUP_DATA_SET)

export const setTimeZoneGroupData = createAction(ActionTypes.TIME_ZONE_GROUP_DATA_SET)

export const setAllApprovers = createAction(ActionTypes.ALL_APPROVERS_SET)

export const setFullUserInfo = (info) => (dispatch) => {
    dispatch(setSimpleFullUserInfo(info))

    if (info.userGroupId)
        dispatch(setUserGroupData({groupId: info.userGroupId}))

    if (info.timeZoneGroupId)
        dispatch(setTimeZoneGroupData({groupId: info.timeZoneGroupId}))
}

export const validateTimeZoneGroup = (tzgId, newTzg) => (dispatch, getState) => {
    dispatch(removeUserPanelErrors([
        ValidationErrors.DUPLICATE_TIME_ZONE_GROUP,
        ValidationErrors.CITY_DATA_EMPTY,
        ValidationErrors.NEW_TIME_ZONE_GROUP_EMPTY
    ]))

    const state = getState()
    const providerErrors = getUserPanelErrors(state)

    const validationResult = validateTimezoneGroup(providerErrors, tzgId, newTzg)

    dispatch(setUserPanelErrors(validationResult.errors));
}

export const updateStateFromViewerSettings = (viewerSettings) => (dispatch) => {
    dispatch(setViewerSettings(viewerSettings))
    dispatch(setEnabledFeatures(viewerSettings.enabledFeatures))
}

export const resetUserGroupRow = () => (dispatch, getState) => {
    const groupId = getFullUserInfo(getState()).userGroupId
    dispatch(setUserGroupData({
        groupId: groupId,
    }))
}

export const resetTimeZoneGroupRow = () => (dispatch, getState) => {
    const groupId = getFullUserInfo(getState()).timeZoneGroupId
    dispatch(setTimeZoneGroupData({
        groupId: groupId,
    }))
}


// WEBPACK FOOTER //
// ./web/js/panels/user/userData/actions.js